//Event archive
(function($) {
    "use strict";

    const $section_event_archive = $('.section-event-archive');

    if ($section_event_archive.length === 0) return;

    //show the appropriate dates for the currently selected instance_month
    function update_instance_month_dates() {

        // console.log('updating instance month dates')
        const selected_instance_month = $('.sf-field-taxonomy-instance_month option:selected').attr('value');

        //uncheck any date that is not currently selectable
        //get all checked inputs
        $('.sf-field-taxonomy-instance_date input:checked')
            .each(function(){

                if (selected_instance_month === '') {//if three is no selected month
                    // console.log('unchecking', $(this).attr('value'), 'because there is no selected month');
                    $(this).trigger('click'); //uncheck it
                } else if (!$(this).attr('value').startsWith(selected_instance_month)) { //or if the checked date is not in the selected month
                    // console.log('unchecking', $(this).attr('value'), 'because selected month is', selected_instance_month);
                    $(this).trigger('click'); //uncheck it
                } else if ($(this).closest('li').is('[data-sf-count=0]')) { //or if the checkbox is for an option that isn't available in the current month
                    // console.log('unchecking', $(this).attr('value'), 'because date is not available in', selected_instance_month);
                    $(this).trigger('click'); //uncheck it
                }
            })
        ;

        $('.instance-month').addClass('js-hidden'); //hide all months
        if (selected_instance_month) { //then show the optionally selected one
            $('.instance-month[data-instance-month='+selected_instance_month+']').removeClass('js-hidden');
            update_instance_date_colors();
        }
    }

    //update the calendar to set colors on the available dates / selected dates
    function update_instance_date_colors() {
        //reset all instance-date availability and checked classes
        $('.instance-date').removeClass('instance-date--available').removeClass('instance-date--selected')

        //get available dates from sf input
        let $available_dates = jQuery('.sf-field-taxonomy-instance_date li[data-sf-count!=0] input');

        $available_dates.each(function () {
            //find the .instance-date for the current available date
            jQuery('.instance-date[data-date=' + this.value + ']')
                .addClass('instance-date--available')
                .toggleClass('instance-date--selected', this.checked)
            ;
        });
    }

    //on ajax finish update the calendar
    $(document).on("sf:ajaxfinish", ".searchandfilter", function(){
        update_instance_month_dates();
        //so load your lightbox or JS scripts here again
    });
    update_instance_month_dates();


    //when clicking on an instance-date, trigger a click on the SF input and update classes
    $section_event_archive.on("click", ".instance-date--available", function() {
        //find the SF form input
        let $sf_form_instance_date_input =  $('.sf-field-taxonomy-instance_date input[value=' + this.getAttribute('data-date') + ']');
        //trigger a click on it
        $sf_form_instance_date_input.trigger('click');
        //update the instance-date
        $(this).toggleClass('instance-date--selected', $sf_form_instance_date_input.checked);
    });


    //manual ajax load-more
    $section_event_archive.on('click', 'a.load-more', function(e){
        //block the click action
        e.preventDefault();
        //remove the load-more button
        $(this).remove();
        //ajax get events
        $.ajax(
            $(this).attr('href'),
            {
                success: function(data) {
                    //find all events in response and append them to the results
                    $('.sf_results_column > *', data).appendTo($('.sf_results_column'));
                    $('.sf_results_list > *', data).appendTo($('.sf_results_list'));

                    //copy over the new load-more link, if it exists
                    $('.sf_results_pagination', data).appendTo($('.sf_results'));
                },
            }
        )
    });

})(jQuery);